<template>
<div>
    <section>
        <div class="top_wrap w-clearfix">
            <a href="#" class="brand-link w-nav-brand"><img sizes="(max-width: 479px) 98vw, (max-width: 767px) 99vw, (max-width: 1000px) 100vw, 1000px" srcset="@/assets/images/NewSelf_Logo-p-500.webp 500w, @/assets/images/NewSelf_Logo-p-800.webp 800w, @/assets/images/NewSelf_Logo.webp 1000w" alt="" src="@/assets/images/NewSelf_Logo.webp" loading="lazy" class="top-logo"></a>
        </div>
    </section>
    <section class="rep_section">
        <div class="rep-wrap">
            <div class="rep_maindiv">
                <div class="rep_top-headers-div">
                    <div class="text-block-1480"><span class="text-span-349">Congrats {{ user.first_name }}!<br>‍</span>You pre-qualify for our Medical weight loss program!</div>
                    <p class="paragraph-192"><strong>You are only days away </strong>from starting the <strong>last</strong> weight loss program you will ever need.<br><br>Below you will find a <strong>preliminary report </strong>of the potential weight loss you could achieve...however we have seen people CRUSH these numbers.</p>
                </div>
                <div class="rep_weightproj">
                    <div class="rep_table-div"><img src="@/assets/images/NewSelf_BlankTable-01.webp" loading="lazy" sizes="(max-width: 1000px) 100vw, 1000px" srcset="@/assets/images/629d31592c14836450e13ad4254b70fe_NewSelf_BlankTable-01-p-500.webp 500w, @/assets/images/629d31592c14836450e13ad4254b70fe_NewSelf_BlankTable-01-p-800.webp 800w, @/assets/images/NewSelf_BlankTable-01.webp 1000w" alt="">
                        <div class="table_wtbox current">
                            <div class="text-block-1481">Current Weight</div>
                            <div class="text-block-1482">{{user.weight}}</div>
                            <div class="text-block-1483">Pounds</div>
                        </div>
                        <div class="table_wtbox goal">
                            <div class="text-block-1481">Goal Weight</div>
                            <div class="text-block-1482">{{desiredWeight}}</div>
                            <div class="text-block-1483">Pounds</div><img src="@/assets/images/emoji_party.webp" loading="lazy" alt="" class="image-609">
                        </div>
                    </div>
                    <div class="weightlossbox sema">
                        <div class="weightbox_flex">
                            <div class="div-block-2123"><img src="@/assets/images/Sema_straight.webp" loading="lazy" sizes="(max-width: 600px) 100vw, 600px" srcset="@/assets/images/Sema_straight-p-500.webp 500w, @/assets/images/Sema_straight.webp 600w" alt="" class="image-610">
                                <div>
                                    <div class="text-block-1486">Lose an Average of </div>
                                    <div class="text-block-1485">16% Body Weight</div>
                                    <div class="text-block-1484">with Semaglutide</div>
                                </div>
                            </div>
                            <div class="wtprojectionentry">
                                <div class="text-block-1487">New Weight</div>
                                <div class="div-block-2124">
                                    <div class="text-block-1489">{{ (user.weight - (parseInt(user.weight) * 0.16)).toFixed(0) }}</div>
                                    <div class="text-block-1488">lbs.</div>
                                </div>
                                <div class="text-block-1490">Lose {{(parseInt(user.weight) * 0.16).toFixed(0)}} lbs.</div>
                            </div>
                        </div>
                    </div>
                    <div data-w-id="4785e80e-bccb-33b0-1c0f-4fe93a44548b" class="weightlossbox tirzep">
                        <div class="weightbox_flex">
                            <div class="div-block-2123"><img src="@/assets/images/Tirz_straight.webp" loading="lazy" sizes="(max-width: 600px) 100vw, 600px" srcset="@/assets/images/Tirz_straight-p-500.webp 500w, @/assets/images/Tirz_straight.webp 600w" alt="" class="image-610">
                                <div>
                                    <div class="text-block-1486">Lose an Average of </div>
                                    <div class="text-block-1485">22% Body Weight</div>
                                    <div class="text-block-1484">with Tirzepatide</div>
                                </div>
                            </div>
                            <div class="wtprojectionentry">
                                <div class="text-block-1487">New Weight</div>
                                <div class="div-block-2124">
                                    <div class="text-block-1489">{{ (user.weight - (parseInt(user.weight) * 0.22)).toFixed(0) }}</div>
                                    <div class="text-block-1488">lbs.</div>
                                </div>
                                <div class="text-block-1490">Lose {{(parseInt(user.weight) * 0.22).toFixed(0)}} lbs.</div>
                            </div>
                        </div>
                    </div>
                    <div class="weightlossbox newself">
                        <div class="weightbox_flex">
                            <div class="div-block-2123">
                                <div>
                                    <div class="text-block-1486">1 in 5 People Lose</div>
                                    <div class="text-block-1485">31% Body Weight</div>
                                    <div class="text-block-1484">with NewSelf Programs</div>
                                </div>
                            </div>
                            <div class="wtprojectionentry">
                                <div class="text-block-1487">New Weight</div>
                                <div class="div-block-2124">
                                    <div class="text-block-1489">{{ (user.weight - (parseInt(user.weight) * 0.31)).toFixed(0) }}</div>
                                    <div class="text-block-1488">lbs.</div>
                                </div>
                                <div class="text-block-1490">Lose {{ (parseInt(user.weight) * 0.31).toFixed(0) }} lbs.</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="rep_macros hide-block">
                    <div class="macros-header-div"><img src="@/assets/images/emoji-fire.webp" loading="lazy" sizes="(max-width: 512px) 100vw, 512px" srcset="@/assets/images/emoji-fire-p-500.webp 500w, @/assets/images/emoji-fire.webp 512w" alt="" class="image-611">
                        <div class="macros-header-text">Your Target Macros (Daily)</div>
                    </div>
                    <div class="macros-bullets-div">
                        <div class="macros-bullet">
                            <div class="macros_bullet-flex"><img src="@/assets/images/emoji_bullseye.webp" loading="lazy" sizes="(max-width: 630px) 100vw, 630px" srcset="@/assets/images/emoji_bullseye-p-500.webp 500w, @/assets/images/emoji_bullseye.webp 630w" alt="" class="image-612">
                                <div class="macros-bullet-text">Calories</div>
                            </div>
                            <div class="macros-bullet-text number"><strong><em class="italic-text-5">~ </em></strong>2000 kCal</div>
                        </div>
                        <div class="macros-bullet">
                            <div class="macros_bullet-flex"><img src="@/assets/images/emoji_bullseye.webp" loading="lazy" sizes="(max-width: 630px) 100vw, 630px" srcset="@/assets/images/emoji_bullseye-p-500.webp 500w, @/assets/images/emoji_bullseye.webp 630w" alt="" class="image-612">
                                <div class="macros-bullet-text">Protein</div>
                            </div>
                            <div class="macros-bullet-text number"><strong><em class="italic-text-5">~ </em></strong>220g</div>
                        </div>
                        <div class="macros-bullet">
                            <div class="macros_bullet-flex"><img src="@/assets/images/emoji_bullseye.webp" loading="lazy" sizes="(max-width: 630px) 100vw, 630px" srcset="@/assets/images/emoji_bullseye-p-500.webp 500w, @/assets/images/emoji_bullseye.webp 630w" alt="" class="image-612">
                                <div class="macros-bullet-text">Carbs</div>
                            </div>
                            <div class="macros-bullet-text number"><strong><em class="italic-text-5">~ </em></strong>120 - 140g</div>
                        </div>
                        <div class="macros-bullet bottom">
                            <div class="macros_bullet-flex"><img src="@/assets/images/emoji_bullseye.webp" loading="lazy" sizes="(max-width: 630px) 100vw, 630px" srcset="@/assets/images/emoji_bullseye-p-500.webp 500w, @/assets/images/emoji_bullseye.webp 630w" alt="" class="image-612">
                                <div class="macros-bullet-text">Fats</div>
                            </div>
                            <div class="macros-bullet-text number"><strong><em class="italic-text-5">~ </em></strong>250-60g</div>
                        </div>
                    </div>
                </div>
                <div class="rep_benefitsdiv">
                    <div class="div-block-2128">
                        <div class="text-block-1492">What You Can <span class="text-span-351">Expect</span></div>
                        <p class="paragraph-193">Join the millions of Americans losing weight and <strong>start seeing results in as little as 4 weeks!</strong></p>
                        <div class="div-block-2125">
                            <div class="div-block-2126">
                                <div class="div-block-2127">
                                    <div class="text-block-1491">Lose weight</div>
                                    <div class="text-block-1493">On average, users <span class="text-span-350">lose around 16-22%</span> of their body weight</div>
                                </div>
                                <div class="div-block-2127">
                                    <div class="text-block-1491">Feel fuller, longer</div>
                                    <div class="text-block-1493">GLP meds <span class="text-span-350">suppresses appetite</span> and curbs food cravings**</div>
                                </div>
                            </div>
                            <div class="div-block-2126">
                                <div class="div-block-2127">
                                    <div class="text-block-1491">Reduce cholesterol</div>
                                    <div class="text-block-1493">GLP meds have been shown to <span class="text-span-350">reduce total cholesterol, </span> LDL cholesterol &amp; triglycerides**</div>
                                </div>
                                <div class="div-block-2127">
                                    <div class="text-block-1491">Improve heart health</div>
                                    <div class="text-block-1493"><span class="text-span-350">Prevent heart attacks</span> and reduce the risk of major cardiac events***</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="rep_4boxes">
                    <div class="boxes-right-div-copy">
                        <div class="box-row-div">
                            <div class="box-div-2 _1"><img loading="lazy" src="@/assets/images/icon_scale_1.svg" alt="" class="image-434">
                                <div class="text-block-887">22%</div>
                                <div class="text-block-894">Lose up to 22% of your body weight**</div>
                            </div>
                            <div class="box-div-2 _2"><img loading="lazy" src="@/assets/images/icon_trophy.svg" alt="" class="image-434">
                                <div class="text-block-887">6X More</div>
                                <div class="text-block-894">weight loss compared to diet and exercise alone</div>
                            </div>
                        </div>
                        <div class="box-row-div">
                            <div class="box-div-2 _3"><img loading="lazy" src="@/assets/images/icon_measure.svg" alt="" class="image-434">
                                <div class="text-block-887">6.9%</div>
                                <div class="text-block-894">Average reduction in waist-to-height ratio, a critical indicator of body fat.**</div>
                            </div>
                            <div class="box-div-2 _4"><img loading="lazy" src="@/assets/images/icon_shipping.svg" alt="" class="image-434">
                                <div class="text-block-887">72 Hours</div>
                                <div class="text-block-894">If approved, medication will ship within 72 hours</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="rep_issues">
                    <div class="issues_div">
                        <div class="issues_header">Weight struggles can take away life’s simple pleasures</div>
                        <div class="issues_flex-copy">
                            <div class="issues_half-div-copy">
                                <div class="issues_bullet">
                                    <div class="text-block-1053">Persistent fatigue</div><img src="@/assets/images/IconSet_batt.webp" loading="lazy" alt="" class="image-482">
                                </div>
                                <div class="issues_line"></div>
                                <div class="issues_bullet">
                                    <div class="text-block-1053">Emotional stress</div><img src="@/assets/images/IconSet_heart.webp" loading="lazy" alt="" class="image-482">
                                </div>
                                <div class="issues_line"></div>
                                <div class="issues_bullet">
                                    <div class="text-block-1053">Increased appetite</div><img src="@/assets/images/IconSet_mind.webp" loading="lazy" alt="" class="image-482">
                                </div>
                                <div class="issues_line"></div>
                                <div class="issues_bullet">
                                    <div class="text-block-1053">Compromised mobility</div><img src="@/assets/images/IconSet_exercise.webp" loading="lazy" alt="" class="image-482">
                                </div>
                                <div class="issues_line"></div>
                            </div>
                            <div class="issues_half-div-copy">
                                <div class="issues_bullet">
                                    <div class="text-block-1053">Low mood/anxiety</div><img src="@/assets/images/IconSet_anxiety.webp" loading="lazy" alt="" class="image-482">
                                </div>
                                <div class="issues_line"></div>
                                <div class="issues_bullet">
                                    <div class="text-block-1053">Difficulty with weight regulation</div><img src="@/assets/images/IconSet_scale.webp" loading="lazy" alt="" class="image-482">
                                </div>
                                <div class="issues_line"></div>
                                <div class="issues_bullet">
                                    <div class="text-block-1053">Low self-esteem</div><img src="@/assets/images/IconSet_mood.webp" loading="lazy" alt="" class="image-482">
                                </div>
                                <div class="issues_line"></div>
                                <div class="issues_bullet">
                                    <div class="text-block-1053">Sleep disturbances</div><img src="@/assets/images/IconSet_Sleep.webp" loading="lazy" alt="" class="image-482">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="rep_savings">
                    <div class="huge-savings-div">
                        <div class="div-block-1633-copy">
                            <div class="text-block-672">All Dosages are the Same Low Price</div>
                            <div class="text-block-652 report">We do not charge you double like competitors when you increase your dosage in the next 3 months.</div>
                        </div>
                        <div class="div-block-1621">
                            <div class="summary-entry-2">
                                <div class="savings-bullet-div"><img loading="lazy" src="@/assets/images/icon_stetoscope.webp" alt="" class="image-348 report">
                                    <div class="text-block-664 report">Doctor Support<br>and Monitoring</div>
                                </div>
                                <div class="item-price">
                                    <div class="no-discount-price step-2 report"><sup>$</sup>99</div>
                                    <div class="text-block-648 report">Free</div>
                                </div>
                            </div>
                            <div class="summary-entry-2">
                                <div class="savings-bullet-div"><img loading="lazy" src="@/assets/images/icon_clipboard.webp" alt="" class="image-348 report">
                                    <div class="text-block-664 report">Metabolic Weight Plan</div>
                                </div>
                                <div class="item-price">
                                    <div class="no-discount-price step-2 report"><sup>$</sup>75</div>
                                    <div class="text-block-648 report">Free</div>
                                </div>
                            </div>
                            <div class="summary-entry-2">
                                <div class="savings-bullet-div"><img loading="lazy" src="@/assets/images/Icon_stepsDeliver.webp" alt="" class="image-348 report van">
                                    <div class="text-block-664 report">Free Express Shipping</div>
                                </div>
                                <div class="item-price">
                                    <div class="no-discount-price step-2 report"><sup>$</sup>40</div>
                                    <div class="text-block-648 report">Free</div>
                                </div>
                            </div>
                            <div class="summary-entry-2">
                                <div class="savings-bullet-div"><img sizes="(max-width: 1080px) 100vw, 1080px" srcset="@/assets/images/BoxImage_PhoneQuiz-p-500.webp 500w, @/assets/images/BoxImage_PhoneQuiz-p-800.webp 800w, @/assets/images/BoxImage_PhoneQuiz.webp 1080w" alt="" src="@/assets/images/BoxImage_PhoneQuiz.webp" loading="lazy" class="image-348 report van">
                                    <div class="text-block-664 report">Never Pay Monthly Membership Fees</div>
                                </div>
                                <div class="item-price">
                                    <div class="no-discount-price step-2 report"><sup>$</sup>99</div>
                                    <div class="text-block-648 report">Free</div>
                                </div>
                            </div>
                            <div class="savings-div-2-copy"><img loading="lazy" src="@/assets/images/party-popper.webp" alt="" class="image-347">
                                <div class="text-block-651 report">You saved <sup>$</sup>313 on your order!</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="rep_testi">
                    <div class="testimonial-div-2 c">
                        <div class="div-block-2130"><img sizes="100vw" srcset="@/assets/images/ba_TF04-p-500.webp 500w, @/assets/images/ba_TF04.webp 650w" alt="" src="@/assets/images/ba_TF04.webp" loading="lazy" class="image-614"></div>
                        <div class="div-block-2129"><img loading="lazy" src="@/assets/images/icon_stars_1.svg" alt="" class="image-613">
                            <div class="text-block-1494">I couldn&#x27;t imagine life without my GLP weekly routine!</div>
                            <p class="paragraph-194">&quot;I went from 287 pounds all the way to to 165 pounds...all thanks to a healthier diet, exercise and most importantly my weekly injections!&quot;</p>
                            <div class="text-block-1495">Jason, lost 122 lbs.</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <div class="w-layout-blockcontainer container_pagebutton w-container" style="display: block;">
        <router-link to="/weight-loss-plan" class="link-block-93 w-inline-block">
            <div class="text-block-1496">Click Here To Get Started <span class="text-span-352">-&gt;</span></div>
            <div class="text-block-1497">Don't wait another day to drop Lbs</div>
        </router-link>
    </div>
</div>
</template>

<script>
//import chatImage from "./chartImage.vue"
import {
    mapGetters
} from 'vuex';
export default {
    components: {
        // chatImage
    },
    data() {
        return {
            scrollAmount: 225,
            desiredWeight: 120,
            videos: []
        };
    },
    computed: {
        ...mapGetters([
            'user',
        ]),
        getYear() {
            return new Date().getFullYear();
        },
        isDiscountOffer() {
            return true;
        },
        getPrice() {
            let discountedPrice = 349 - this.discount;

            if (discountedPrice % 1 !== 0) {
                discountedPrice = Math.round(discountedPrice * 100) / 100;
            }
            return discountedPrice;
        },
        discount() {
            if (this.$route.query.offer == "ninetynine") {
                return 250
            } else if (this.$route.query.offer == "oneforty") {
                return 150
            }
            return 0
        }
    },
    mounted() {
        if (this.$route.query.desiredWeight) {
            this.desiredWeight = this.$route.query.desiredWeight;
        }
        if (this.$refs.slider) {
            this.$refs.slider.addEventListener('touchstart', this.handleTouchStart);
            this.$refs.slider.addEventListener('touchmove', this.handleTouchMove);
            this.$refs.slider.addEventListener('touchend', this.handleTouchEnd);
        }
    },
    methods: {
        getDetails() {
            this.people.first_name = this.$route.query.name;
            this.people.weight = this.$route.query.weight;
            this.people.desired_weight = this.$route.query.goal;
        },
        handleTouchStart(event) {
            this.startX = event.touches[0].clientX;
        },
        handleTouchMove(event) {
            this.currentX = event.touches[0].clientX;
        },
        handleTouchEnd() {
            const deltaX = this.currentX - this.startX;
            if (Math.abs(deltaX) > 50) {
                if (deltaX > 0) {
                    this.scrollLeft();
                } else {
                    this.scrollRight();
                }
            }
        },
        scrollLeft() {
            const container = this.$refs.carouselContent;
            container.scrollBy({
                left: -this.scrollAmount,
                behavior: 'smooth'
            });
        },
        scrollRight() {
            const container = this.$refs.carouselContent;
            container.scrollBy({
                left: this.scrollAmount,
                behavior: 'smooth'
            });
        },
        pushToRoute(event) {
            event.preventDefault();
            if (this.$route.query.offer == "ninetynine" || this.$route.query.offer == "oneforty") {
                this.$router.push({
                    name: 'CheckoutOffer',
                    query: {
                        "health_id": this.$route.query.health_id,
                        "id": this.$route.query.id,
                        "name": this.$route.query.name,
                        "phase": 1,
                        "plan": "Semaglutide",
                        "pay_terms": 1,
                        "state": this.$route.query.state,
                        "aegate": "Mjk5",
                        "offer": this.$route.query.offer
                    }
                });
            } else {
                this.$router.push({
                    name: 'CheckoutForm',
                    query: {
                        "health_id": this.$route.query.health_id,
                        "id": this.$route.query.id,
                        "name": this.$route.query.name,
                        "phase": this.$route.query.phase,
                        "plan": this.$route.query.plan,
                        "state": this.$route.query.state,
                        "discount": this.$route.query.discount?? 100,
                    }
                });
            }
        },

        scrolltoTop() {
            setTimeout(function () {
                window.scroll({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                });
            }, 100);
        },
    },
    created() {
        this.scrolltoTop();

    }
};
</script>

<style scoped>
.link-block-93 {
        background-color: var(--color);
        font-family: var(--satoshi);
        border-radius: 11px;
        flex-flow: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        padding: 20px;
        text-decoration: none;
        display: flex;
    }
    .text-block-1497 {
      color: #fff;
      font-size: 14px;
      font-weight: 600;
    }
    .text-block-1496 {
    color: #fff;
    text-align: center;
    margin-bottom: 2px;
    font-size: 21px;
    font-weight: 700;
    line-height: 22px;
}

@media screen and (max-width: 479px) {
    .container_pagebutton {
        background-color: #d9d7d7;
        padding: 10px 1% 10px;
    }

    
}
</style>
